import React from "react";
import { PaymentMethodType, PaymentState } from "../../payment/PaymentConstants";
import TranslatedMessage from "../../translations/TranslatedMessage";

interface PaymentStatusProps {
  state: PaymentState;
  method?: PaymentMethodType | null;
  refunded?: boolean;
}

const PaymentStatus: React.FunctionComponent<PaymentStatusProps> = ({ state, method, refunded }) => {
  const messageId =
      state === PaymentState.EPayment && method === PaymentMethodType.CreditCard && !refunded
      ? "paymentStatus.paid.ePayment.creditCard"
      : state === PaymentState.EPayment && method === PaymentMethodType.CembraPay && !refunded
      ? "paymentStatus.paid.ePayment.cembraPay"
      : state === PaymentState.EPayment && method === PaymentMethodType.CreditCard && refunded
      ? "paymentStatus.refunded.ePayment.creditCard"
      : state === PaymentState.EPayment && method === PaymentMethodType.CembraPay && refunded
      ? "paymentStatus.refunded.ePayment.cembraPay"
      : state === PaymentState.Abacus && !refunded
      ? "paymentStatus.paid.abacus"
      : state === PaymentState.Abacus && refunded
      ? "paymentStatus.refunded.abacus"
      : "paymentStatus.paid.abacus";

  return (
    <>
      <TranslatedMessage id={messageId} />
    </>
  );
};

export default PaymentStatus;
